import { uniq } from 'lodash';

import { useLegacyAllowanceProposalWorkflowTableData } from '~/data/proposals/useGetLegacyProposalWorkflows';

import { useAllowanceProposalColumns } from '../../../../common';
import {
  ProposalWorkflowTablePropsType,
  ProposalsWorkflowTableLayout,
} from '../common';

export const AllowanceProposalWorkflowTable = (
  props: ProposalWorkflowTablePropsType,
) => {
  const { data: rows } = useLegacyAllowanceProposalWorkflowTableData(props);
  const columns = useAllowanceProposalColumns({
    employmentIds: uniq(rows.map((r) => r.fEmplId)),
  });

  return <ProposalsWorkflowTableLayout rows={rows} columns={columns} />;
};
